import React from 'react';
import { RouteProps } from 'react-router-dom';
import { authPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	{ path: authPagesMenu.login.path, element: null },
	{ path: authPagesMenu.forgotPassword.path, element: null },
	{ path: authPagesMenu.signUp.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: '*', element: <DefaultAside /> },
];

export default asides;
